import { SPECS } from '../../constants';
var ProductPriceRange = /** @class */ (function () {
    function ProductPriceRange(siteStore) {
        this.siteStore = siteStore;
    }
    ProductPriceRange.prototype.shouldShowPriceRange = function () {
        return (this.siteStore.experiments.enabled(SPECS.PRICE_RANGE_VIEWER) &&
            Boolean(this.siteStore.priceSettings.showPriceRange));
    };
    return ProductPriceRange;
}());
export { ProductPriceRange };
//# sourceMappingURL=ProductPriceRange.js.map